import api from "../../../../../api";

export const requestGetVinFromImage = (payload) => {
    return api.post("/ocrvinimage/images", payload);
};